import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.debug = () => {};
}
// Global error handler for localStorage/sessionStorage SecurityErrors (third-party scripts)
window.addEventListener(
  "error",
  (event) => {
    if (
      event.error?.name === "SecurityError" &&
      (event.error?.message?.includes("localStorage") ||
        event.error?.message?.includes("sessionStorage") ||
        event.error?.message?.includes("Access is denied"))
    ) {
      console.warn("[Global Error Handler] Storage access denied, continuing:", event.error);
      event.preventDefault();
    }
  },
  true
);

window.addEventListener("unhandledrejection", (event) => {
  if (
    event.reason?.name === "SecurityError" &&
    (event.reason?.message?.includes("localStorage") ||
      event.reason?.message?.includes("sessionStorage") ||
      event.reason?.message?.includes("Access is denied"))
  ) {
    console.warn("[Global Error Handler] Storage access denied in promise, continuing:", event.reason);
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
// index.tsx — runs before React renders anything

// Detect if running as installed PWA
const isPWA = 
  window.matchMedia('(display-mode: standalone)').matches ||
  Boolean((window.navigator as any).standalone);

if (isPWA) {
  console.log('[PWA] Standalone launch detected — flagging fresh registration needed');
  // Use sessionStorage so this flag is fresh every PWA launch
  // (sessionStorage is cleared when PWA is force-closed)
  sessionStorage.setItem('pwa_needs_fresh_registration', 'true');
}
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ─── Service Worker Registration ───────────────────────────────────────────
//
// IMPORTANT: Register ONE service worker only — the unified sw.js.
//
// sw.js now contains BOTH:
//   • Firebase Messaging (onBackgroundMessage, notificationclick)
//   • Workbox caching strategies
//
// The old firebase-messaging-sw.js is NO LONGER REGISTERED here.
// Registering two SWs on the same scope ("/") caused the FCM SW to be
// evicted by the app SW on every activate, breaking push notifications
// after the first delivery.
//
// Do NOT add a separate navigator.serviceWorker.register() call for FCM.
// notificationService.getFCMToken() now uses navigator.serviceWorker.ready
// to bind the token to whichever SW is already controlling the page (sw.js).
// ──────────────────────────────────────────────────────────────────────────

serviceWorkerRegistration.register({
  onSuccess: () => console.log("✅ Service Worker registered (PWA + FCM unified)"),
  onUpdate: (_reg) => {
    // sw.js now calls skipWaiting() and clients.claim(), so the new worker
    // takes over without waiting for every window to close — a waiting worker
    // cannot repair a client that is stuck on a shell it can no longer boot.
    //
    // We still do not force a reload here: interrupting an active session can
    // lose unsaved log entries. If this page ends up asking for an asset the
    // new worker doesn't have, the SW reports it as DEPLOY_SKEW and the
    // recovery routine in index.html reloads onto a matching build.
    console.log(
      "🔄 New app version activated — this tab will catch up on next load",
    );
  },
});

reportWebVitals();
